import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { NotificationService } from '../../../services/notification.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm!: FormGroup;
  isSubmitted: boolean = false;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private notify: NotificationService,
    private http: ApiService
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.changePasswordForm = this.formBuilder.group(
      {
        old_password: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirm_password: ['', Validators.required],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  // Custom Validator for Password Match
  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirm_password = formGroup.get('confirm_password')?.value;
    return password === confirm_password ? null : { mismatch: true };
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }

    const formData = this.changePasswordForm.value;

    this.isLoading = true;
    this.http.post('retailers/changePassword', formData).subscribe(
      (res) => {
        console.log(res);
        this.isLoading = false; // Re-enable the submit button

        if (res.code === 1) {
          this.router.navigate(['/dashboard/profile']);
          this.notify.showSuccess(res.message, '');
        } else {
          this.notify.showError(res.message, '');
        }
      },
      (error) => {
        console.error('Error:', error);
        this.isLoading = false; // Re-enable the submit button
        this.notify.showError('An error occurred. Please try again.', '');
      }
    );
  }

  get errorControl() {
    return this.changePasswordForm.controls;
  }

  goBack() {
    this.router.navigate(['/dashboard/profile']);
  }
}
